import React from 'react'
import { WindowPropertiesProps } from './types'
import {
  PropertySection,
  SectionHeader,
  SectionTitle,
  CollapseIcon,
  SectionContent,
  PropertyGroup,
  Label,
  Input,
  InfoText,
  Select,
  Checkbox,
} from '../styled'
import {
  getUnitSingular,
  getDefaultWindowWidth,
  getDefaultWindowHeight,
  formatStandardWindowWidth,
  formatStandardWindowHeight,
} from '../helpers'

const WindowProperties: React.FC<WindowPropertiesProps> = ({
  selectedElement,
  mapSettings,
  localProperties,
  isCollapsed,
  onToggleSection,
  updateProperty,
  updateMeasurement,
  onUpdateElement,
}) => {
  return (
    <PropertySection>
      <SectionHeader isCollapsed={isCollapsed} onClick={onToggleSection}>
        <SectionTitle>Window Properties</SectionTitle>
        <CollapseIcon isCollapsed={isCollapsed}>▼</CollapseIcon>
      </SectionHeader>
      <SectionContent isCollapsed={isCollapsed}>
        <PropertyGroup>
          <Label>Window Width ({getUnitSingular(mapSettings)})</Label>
          <Input
            type="number"
            step="0.1"
            value={(
              selectedElement.measurements?.realWidth ||
              getDefaultWindowWidth(mapSettings)
            ).toFixed(1)}
            onChange={e =>
              updateMeasurement('realWidth', Number(e.target.value))
            }
          />
          <InfoText>
            Standard: {formatStandardWindowWidth(mapSettings)}
          </InfoText>
        </PropertyGroup>
        <PropertyGroup>
          <Label>Window Height ({getUnitSingular(mapSettings)})</Label>
          <Input
            type="number"
            step="0.1"
            value={(
              selectedElement.measurements?.realHeight ||
              getDefaultWindowHeight(mapSettings)
            ).toFixed(1)}
            onChange={e =>
              updateMeasurement('realHeight', Number(e.target.value))
            }
          />
          <InfoText>
            Standard: {formatStandardWindowHeight(mapSettings)}
          </InfoText>
        </PropertyGroup>
        <PropertyGroup>
          <Label>Window Type</Label>
          <Select
            value={localProperties.windowType || 'double-hung'}
            onChange={e => updateProperty('windowType', e.target.value)}>
            <option value="double-hung">Double Hung</option>
            <option value="casement">Casement</option>
            <option value="sliding">Sliding</option>
            <option value="fixed">Fixed/Picture</option>
            <option value="bay">Bay Window</option>
            <option value="awning">Awning</option>
          </Select>
        </PropertyGroup>
        <PropertyGroup>
          <Label>Frame Material</Label>
          <Select
            value={localProperties.material || 'vinyl'}
            onChange={e => updateProperty('material', e.target.value)}>
            <option value="vinyl">Vinyl</option>
            <option value="wood">Wood</option>
            <option value="aluminum">Aluminum</option>
            <option value="fiberglass">Fiberglass</option>
            <option value="composite">Composite</option>
          </Select>
        </PropertyGroup>
        <PropertyGroup>
          <Label>Glazing</Label>
          <Select
            value={localProperties.glazing || 'double'}
            onChange={e => updateProperty('glazing', e.target.value)}>
            <option value="single">Single Pane</option>
            <option value="double">Double Pane</option>
            <option value="triple">Triple Pane</option>
            <option value="low-e">Low-E Coating</option>
          </Select>
        </PropertyGroup>
        <PropertyGroup>
          <Label>Window Label</Label>
          <Input
            value={localProperties.label || ''}
            onChange={e => updateProperty('label', e.target.value)}
            placeholder="e.g., Bay Window, Kitchen Window"
          />
        </PropertyGroup>
        <PropertyGroup>
          <Label>
            <Checkbox
              checked={selectedElement.locked || false}
              onChange={e =>
                onUpdateElement(selectedElement.id, {
                  locked: e.target.checked,
                })
              }
            />
            Lock from Dragging
          </Label>
        </PropertyGroup>
      </SectionContent>
    </PropertySection>
  )
}

export { WindowProperties }
